var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableChairD = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17.631 10.8h24.99v18.771h-24.99z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M49.2 30.546A18.66 18.66 0 0 1 30.546 49.2h-1.092A18.66 18.66 0 0 1 10.8 30.546a4.147 4.147 0 0 1 4.146-4.146h30.108a4.147 4.147 0 0 1 4.146 4.146"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 6,
  d: "M9.6 19.602v0a9.9 9.9 0 0 1 9.81-8.535h21.18a9.9 9.9 0 0 1 9.81 8.535v0"
})));
SvgNoTableChairD.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableChairD);
export default ForwardRef;